import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  useDisclosure
} from '@chakra-ui/react';
import UserFinderTab from './UserFinderTab';
import MessagesTab from '../../components/Messages/MessagesTab';
import FriendsListTab from '../../components/Friends/FriendsListTab';
import SendMessageModal from '../../components/Messages/SendMessageModal';

const CommunityModal = ({ isOpen, onClose }) => {
  const [tabIndex, setTabIndex] = useState(2); // Default to Messages tab
  const sendMessageModal = useDisclosure();
  const [initialRecipient, setInitialRecipient] = useState(null);
  
  // Listen for events to open the community modal with specific settings
  useEffect(() => {
    const handleOpenCommunityModal = (event) => {
      if (event.detail) {
        // Set tab index if provided
        if (typeof event.detail.tabIndex === 'number') {
          setTabIndex(event.detail.tabIndex);
        }
        
        // Open send message modal if requested
        if (event.detail.openSendMessage) {
          setInitialRecipient(event.detail.recipientId);
          setTimeout(() => {
            sendMessageModal.onOpen();
          }, 300); // Small delay to ensure modal is ready
        }
      }
    };
    
    // Add event listener
    document.addEventListener('openCommunityModal', handleOpenCommunityModal);
    
    // Cleanup
    return () => {
      document.removeEventListener('openCommunityModal', handleOpenCommunityModal);
    };
  }, []);
  
  useEffect(() => {
    console.log('CommunityModal mounted');
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size={{ base: "full", md: "4xl" }}>      
        <ModalOverlay />
        <ModalContent 
          maxW={{ base: "100%", md: "1000px" }} 
          mx={{ base: 0, md: "auto" }}
          my={{ base: 0, md: "3.75rem" }}
          borderRadius={{ base: 0, md: "md" }}
          bg="gray.800" 
          color="white"
        >
          <ModalHeader>Burrow Community</ModalHeader>
          <ModalCloseButton />
          <ModalBody px={{ base: 2, md: 6 }} pb={{ base: 2, md: 6 }}>
            <Tabs index={tabIndex} onChange={setTabIndex}>
              <TabList>
                <Tab>Kin</Tab>
                <Tab>User Finder</Tab>
                <Tab>Messages</Tab>
              </TabList>
              <TabPanels>              
                <TabPanel>
                  <FriendsListTab />
                </TabPanel>
                <TabPanel>
                  <UserFinderTab />
                </TabPanel>              
                <TabPanel p={{ base: 0, md: 4 }}>
                  <MessagesTab 
                    openSendMessage={() => {
                      sendMessageModal.onOpen();
                    }}
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
        </ModalContent>
      </Modal>
      
      {/* Direct Message Modal accessible from chat message details */}
      <SendMessageModal 
        isOpen={sendMessageModal.isOpen} 
        onClose={sendMessageModal.onClose}
        initialRecipient={initialRecipient}
      />
    </>
  );
};

export default CommunityModal;
